<div class="container" *ngIf=!mostrar >
    <div class="shadow p-3 mb-3 mt-3 bg-white rounded">
        <div class="row">
            <div class="column">
                <div class="card-body">
                    <h3 class="text-primary text-center">Autorización   </h3>
                    <h2 class="text-primary text-center"><strong>Pagos a través de Banco </strong></h2>
                    <br>
                    <div class="container-fluid">
                        <p class="text-align: justify">Por el presente instrumento, la persona individualizada más adelante, autoriza a la Dirección de Contabilidad  y  Finanzas, para que abone en la cuenta que se  indica,  los montos presentados a cobro a los  Servicios o  Direcciones  del       Ministerio  de Obras  Públicas.
                        </p>
                        <p class="text-align: justify">La presente autorización comenzará a regir a partir del tercer día hábil siguiente en que el instrumento sea recibido en la Dirección de Contabilidad y Finanzas y se otorga por un plazo indefinido, sin perjuicio de poder revocarla, notificando por escrito con a lo menos tres días hábiles de anticipación a la fecha requerida de revocación. También será causal de expiración el cierre de la cuenta individualizada.La Información que se detalla en esta autorización es de exclusiva responsabilidad del beneficiario, eximiendo a la Dirección de Contabilidad y finanzas de toda responsabilidad por errores o imprecisiones en los datos entregados.
                            Las personas jurídicas deberán acreditar su representación mediante los instrumentos requeridos.
                        </p>
                    </div>
                    <hr>
                    <form autocomplete="off" [formGroup]="forma" (ngSubmit)="guardar();" >
                        <div class="form-group row mb-2">
                            <label class="col-2 col-form-label" name="lrut">Rut Representante</label>
                            <div class="col-3">
                                <h4 class="text-secondary">{{rut}}  {{nombre}} {{apellidop}} {{apellidom}}</h4>
                            </div> <!-- Termina  col -->
                        </div> <!-- Termina form group Rut-->
                        <div class="form-group row mb-2">
                            <label class="col-2 col-form-label">Rut Empresa</label>
                            <div class="col-3">
                                <input class="form-control" type="text" placeholder="Rut Empresa" formControlName="rut" [class.is-invalid]="rutNoValido" minlength="7" maxlength="8">
                                <small *ngIf="rutNoValido" class="text-danger">
                                    Ingrese Rut válido. (Ingrese Rut sin guión ni dígito)
                                </small>
                            </div>
                        </div>
                        <div class="form-group row mb-2">
                            <label class="col-2 col-form-label">Región</label>
                            <div class="col-8">
                                <select class='form-select' formControlName="region" (change)="onRegionChange($event)">
                                    <option value="">Selecciona región</option>
                                    <option value="15">Arica y Parinacota </option>
                                    <option value="1">Tarapacá</option>
                                    <option value="2">Antofagasta</option>
                                    <option value="3">Atacama</option>
                                    <option value="4">Coquimbo</option>
                                    <option value="5">Valparaíso</option>
                                    <option value="6">O'Higgins</option>
                                    <option value="7">Maule</option>
                                    <option value="8">Biobío</option>
                                    <option value="9">Araucanía</option>
                                    <option value="14">Los Ríos</option>
                                    <option value="16">Metropolitana -  Bombero Salas 1351</option>
                                    <option value="10">Los Lagos</option>
                                    <option value="11">Aysén</option>
                                    <option value="12">Magallanes</option>
                                    <option value="13">Nivel Central - Morandé 71</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row mb-2">
                            <label class="col-2 col-form-label">Correo</label>
                            <div class="col-6">
                                <input class="form-control" type="email" preventCutCopyPaste placeholder="Correo electrónico" formControlName="correo" [class.is-invalid]="correoNoValido">
                                <small *ngIf="correoNoValido" class="text-danger">
                                    Correo no válido.
                                </small>
                            </div>
                        </div>
                        <div class="form-group row mb-2">
                            <label class="col-2 col-form-label">Repita</label>
                            <div class="col-6">
                                <input class="form-control"
                                type="email"
                                preventCutCopyPaste
                                placeholder="Repita Correo"
                                formControlName="correo2"
                                [class.is-invalid]="correo2NoValido">
                                <small *ngIf="correo2NoValido" class="text-danger">
                                    Correo no válido.
                                </small>
                            </div>
                        </div>
                        <div class="form-group row mb-2">
                            <label class="col-2 col-form-label" name="tiposolicitud"><b> Tipo de Solicitud </b></label>
                            <div class="col-auto">
                                <select class="form-select" formControlName="tiposolicitud" (change)="onSolChange($event)" placeholder="Selecciona Tipo de Solicitud" >
                                    <option value="">Selecciona Tipo de Solicitud</option>
                                    <option value="A">Agregar Cuenta</option>
                                    <option value="R">Revocar Cuenta</option>
                                </select>
                            </div> <!-- Termina  col -->  
                        </div> <!-- Termina form group cuenta-->
                        <div class="form-group row mb-2">
                            <label class="col-2 col-form-label" name="cuenta">Cuenta</label>
                            <div class="col-6">
                                <input class="form-control" type="text" placeholder="Cuenta" formControlName="cuenta" [class.is-invalid]="cuentaNoValida">
                                <small *ngIf="cuentaNoValida" class="text-danger">
                                    Cuenta no válida.
                                </small>
                            </div> <!-- Termina  col -->
                        </div> <!-- Termina form group cuenta-->
                        <div class="form-group row mb-2">
                            <label class="col-2 col-form-label" name="cuenta">Tipo de Cuenta</label>
                            <div class="col-auto">
                                <select class="form-select" formControlName="tipocuenta" (change)="onTipoCuenta($event)" >
                                    <option value="">Selecciona Tipo de Cuenta</option>
                                    <option value="1">Cuenta Corriente</option>
                                    <option value="2">Cuenta Vista</option>
                                    <option value="3">Cuenta de Ahorro</option>
                                    <option value="4">Chequera Electrónica</option>
                                    <option value="5">Cuenta Rut</option>
                                </select>
                            </div> <!-- Termina  col -->
                        </div> <!-- Termina form group cuenta-->
                        <div class="form-group row mb-2">
                            <label class="col-2 col-form-label" name="cuenta">Banco</label>
                            <div class="col-auto">
                                <select class="form-select" formControlName="banco" (change)="onBancoChange($event)">
                                    <option value="">Selecciona Banco</option>
                                    <option value="012">Banco Estado</option>
                                    <option value="001">Banco de Chile </option>
                                    <option value="016">Banco de Crédito e Inversiones (BCI)</option>
                                    <option value="028">Banco Bice</option>
                                    <option value="031">HSBC Bank</option>
                                    <option value="037">Banco Santander</option>
                                    <option value="039">Itaú / Corpbanca</option>
                                    <option value="049">Banco Security</option>
                                    <option value="014">Scotiabank</option>
                                    <option value="504">Scotiabank Azul</option>
                                    <option value="051">Banco Falabella</option>
                                    <option value="053">Banco Ripley</option>
                                    <option value="055">Banco Consorcio</option>
                                    <option value="059">Banco BTG Pactual Chile</option>
                                    <option value="009">Banco Internacional</option>
                                </select>
                            </div> <!-- Termina  col --> 
                        </div> <!-- Termina form group cuenta-->
                        <br>
                        <hr>
                        <label class="col-12 col-form-label"> <b>Sólo en caso de persona jurídica </b></label>
                        
                        <div class="form-group row">
                            <label class="col-2 col-form-label">Documentos (PDF)</label>
                            <br>
                            <label class="col-12 col-form-label">1.- Certificado de Vigencia de Sociedad del Registro de comercio.</label>
                            <div class="col">
                                <input class="form-control" formControlName="documento" type="file" (change)="fileChanged($event)" accept=".pdf" lang="es">  
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="col-2 col-form-label"> </label>
                            <label class="col-12 col-form-label">2.	Certificado de Vigencia de Poder del Registro de Comercio.</label>
                            <div class="col">
                                <input class="form-control" type="file" formControlName="doc2" (change)="fileCambio($event)" accept=".pdf" lang="es"> 
                            </div>
                        </div>
                        <br>
                    
                        <div class="form-group row">
                            <div class="col-4">  </div>
                            <div class="col-auto">
                                <button type="submit" class="btn btn-outline-primary  ">
                                Solicitar 
                                </button> 
                                <button type="button" (click)="verInicio()" class="btn btn-outline-primary  ">
                                Volver
                                </button>
                            </div>
                        </div>
                    </form>
                </div> <!-- Termina div BODY -->
            </div> <!-- Termina div COLUMN -->
        </div> <!-- Termina div row -->
    </div> <!-- Termina div shadow -->
</div> <!-- Termina div de rut /folio mostrar -->
  
<div  class ="container" *ngIf = alerta >
    <br><br>
    <div class="shadow  bg-white rounded">
        <br><br>
        <div class="row"> 
            <div class="card-column" style="width: 7rem;border:0ch" >
            </div>
            <div class="card-column" style="width: 60rem;border:0ch" >
                <h1 class="text-primary"><strong> Estimado Usuario/a  </strong></h1>
                <h3 class="text-primary"><small>Registro correctamente enviado! </small></h3>
                <h3 class="text-primary"><small>Número de Solicitud :  {{result}} </small></h3>
                <p></p>
                <br><br>
                <button (click)="cerrar();" type="button" class="btn btn-outline-secondary">Volver
                    <svg class="bi bi-arrow-left-square-fill" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" color="green" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.354 10.646a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L6.207 7.5H11a.5.5 0 0 1 0 1H6.207l2.147 2.146z"/>
                    </svg>
                </button>
            </div> <!-- Cardcolumn-->
        </div> <!-- fila--> 
        <br><br>
    </div>  
    <br><br>
</div><!-- fin de alerta-->
<script async src="https://www.googletagmanager.com/gtag/js?id=UA-10529528-23"></script>
<script>
    window.dataLayer = window.dataLayer || [];
    function gtag(){
        dataLayer.push(arguments);
    }
    
    gtag('js', new Date());
    gtag('config', 'UA-10529528-23');
    gtag('event', 'Fin de la solicitud ', {
        'event_category': 'Trámite digital',
        'event_label': 'Trámite - 1000830000',
        'value': '0'   
    });
   
</script>